// @flow

require('promise.prototype.finally').shim();
import createHistory from 'history/createBrowserHistory';
import {MuiThemeProvider} from 'material-ui';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import React from 'react';
import ReactDOM from 'react-dom';
import HttpsRedirect from 'react-https-redirect';
import {Provider} from 'react-redux';
import injectTapEventPlugin from 'react-tap-event-plugin';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import App from './App';
import './index.css';
import configureStore from './store/configureStore';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

export const history = createHistory();
export const store = configureStore();
const muiTheme = getMuiTheme({
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: '#665eb8'
  }
});

ReactDOM.render(
  <MuiThemeProvider muiTheme={muiTheme}>
    <Provider store={store}>
      <HttpsRedirect>
        <App/>
      </HttpsRedirect>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js